<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-menu-button></ion-menu-button>
        </ion-buttons>
        <ion-title>
            <ion-img
                class="amoLogo"
                src="assets/icons/logo_orange.png"
            ></ion-img>
        </ion-title>
        <ion-buttons slot="end" *ngIf="!(censorContent$ | async)">
            <ion-button type="button" (click)="openSidebar()">
                <ion-icon
                    class="helpIcon"
                    name="help-circle"
                    slot="icon-only"
                ></ion-icon>
            </ion-button>
            <!-- <ion-button type="button" (click)="openItinerarySidebar()">
          <ion-icon class="helpIcon" name="list" slot="icon-only"></ion-icon>
        </ion-button> -->
        </ion-buttons>
        <ion-buttons slot="end" *ngIf="(censorContent$ | async)">
            <ion-button type="button">
                <ion-icon
                    class="helpIcon"
                    name="help-circle"
                    slot="icon-only"
                    style="color: transparent;"
                ></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content #content>
    <!-- <ion-toolbar id="toolbar">
        <ion-item slot="start" lines="none">
            <h3 class="page-title">
                Welcome to your AMO Dashboard!
            </h3>
        </ion-item>
    </ion-toolbar> -->
    <ion-grid class="ion-no-padding" *ngIf="!loading">
        <!-- Remove this style when page is ready -->
        <ion-row style="height: 100vh">
            <ion-col
                size-xl="3"
                size-lg="4"
                size-md="0"
                size-sm="0"
                size-xs="0"
                class="col-left no-padding-col"
            >
                <app-sidebar-general-content
                    [applications]="chainedApplications"
                    [application]="null"
                    [path]="'statusPage'"
                    *ngIf="!(censorContent$ | async)"
                >
                </app-sidebar-general-content>
            </ion-col>

            <ion-col
                size-xl="9"
                size-lg="8"
                size-md="12"
                size-sm="12"
                size-xs="12"
                class="col-right"
            >
                <div
                    *ngIf="noChain === true"
                    style="margin-top: 10em"
                    class="ion-text-center"
                >
                    <ion-item lines="none" class="ion-text-center">
                        <ion-label class="no-apps-text">
                            <fa-icon
                                [icon]="faExclamationCircle"
                                class="fa-line-padding"
                                style="color: var(--ion-color-primary)"
                            >
                            </fa-icon
                            >No Active Applications Found. {{
                            chainedApplications }}
                        </ion-label>
                    </ion-item>
                    <div class="begin-search-container">
                        <ion-button color="primary" [routerLink]="['/search']">
                            <ion-icon slot="start" name="search"></ion-icon>
                            <ion-text class="ion-text-wrap">
                                Search for clinical experiences and build your
                                itinerary.
                            </ion-text>
                        </ion-button>
                    </div>
                </div>

                <div
                    *ngIf="applicationChainState === 'Pending' || applicationChainState === 'Accepted' || applicationChainState === 'Reserved'"
                >
                    <div>
                        <app-application-chain-list
                            [chainedApplications]="chainedApplications"
                            (onApplicationSelection)="openProgramDetails($event)"
                        ></app-application-chain-list>
                    </div>
                    <ion-toolbar>
                        <ion-segment
                            [(ngModel)]="segmentView"
                            (ionChange)="segmentChanged($event)"
                            mode="md"
                            class="ion-margin-top"
                        >
                            <ion-segment-button value="application" mode="md">
                                <ion-label class="segment-label"
                                    >Application</ion-label
                                >
                            </ion-segment-button>
                            <ion-segment-button value="program" mode="md">
                                <ion-label class="segment-label"
                                    >Program Details</ion-label
                                >
                            </ion-segment-button>
                        </ion-segment>
                    </ion-toolbar>
                </div>
                <div [ngSwitch]="segmentView">
                    <div *ngSwitchCase="'application'">
                        <div
                            *ngIf="applicationChainState === 'Pending' || applicationChainState === 'Pending-Booked'"
                        >
                            <div class="ion-text-center required-doc-title">
                                <h3>
                                    Verify your eligibility
                                </h3>
                                <p>
                                    <span *ngIf="preApprovalFound">
                                        You have rotation(s) that require
                                        pre-approval.
                                    </span>
                                    Please submit your required documents as
                                    soon as possible. We will review your
                                    application and accept you if you meet the
                                    requirements.
                                </p>
                            </div>
                            <div>
                                <app-application-chain-document-list
                                    [chainedApplications]="chainedApplications"
                                    [profile]="profile"
                                    [applicationChainState]="applicationChainState"
                                ></app-application-chain-document-list>
                            </div>
                        </div>
                        <div *ngIf="applicationChainState === 'Accepted'">
                            <div>
                                <div class="ion-text-center required-doc-title">
                                    <h3>
                                        Reserve your Experiences
                                    </h3>

                                    <section class="ion-margin-bottom">
                                        <ion-text color="text">
                                            <p>
                                                Your applications are accepted,
                                                make your reservation payment to
                                                secure your experiences for the
                                                dates selected.
                                            </p>
                                        </ion-text>
                                    </section>
                                    <ion-button (click)="goToChainPayment()">
                                        Pay and Reserve All
                                    </ion-button>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="applicationChainState === 'Reserved'">
                            <div>
                                <div
                                    *ngIf="profile?.madeApplicationPayment === false"
                                >
                                    <div>
                                        <div
                                            class="ion-text-center required-doc-title"
                                        >
                                            <h3>
                                                Complete your final payment
                                            </h3>
                                            <ion-button
                                                (click)="goToChainPayment()"
                                            >
                                                Pay your final payment
                                            </ion-button>
                                        </div>
                                    </div>
                                </div>
                                <div class="ion-text-center required-doc-title">
                                    <h3>
                                        Complete your reservation
                                    </h3>
                                    <p>
                                        Please submit your required documents as
                                        soon as possible.
                                    </p>
                                </div>
                                <div>
                                    <app-application-chain-document-list
                                        [chainedApplications]="chainedApplications"
                                        [profile]="profile"
                                        [applicationChainState]="applicationChainState"
                                    ></app-application-chain-document-list>
                                </div>
                                <div
                                    class="ion-margin-top ion-margin-bottom"
                                    *ngIf="profile?.chainContractsSigned"
                                >
                                    <div
                                        [ngClass]="pendingEnrollment ? 'circle-container-pending' : (applicationChainEnrollment$ | async) ? 'circle-container-ready' : 'circle-container'"
                                        (click)="requestEnrollment()"
                                    >
                                        <div class="circle">
                                            <div class="circle-content">
                                                <div>
                                                    <fa-icon
                                                        slot="start"
                                                        [icon]="faUserMd"
                                                    ></fa-icon>
                                                </div>
                                                <div
                                                    *ngIf="pendingEnrollment"
                                                    class="pending-button-text"
                                                >
                                                    Your enrollment request is
                                                    under review
                                                </div>
                                                <div
                                                    *ngIf="!pendingEnrollment"
                                                    [innerHTML]="(toolService.content | async)?.application?.components?.reserved?.enrollButton"
                                                ></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            *ngIf="applicationChainState === 'Enrolled' || applicationChainState === 'Completed'"
                        >
                            <app-application-chain-enrolled
                                [chainedApplications]="chainedApplications"
                                [profile]="profile"
                                [applicationChainState]="applicationChainState"
                            ></app-application-chain-enrolled>
                        </div>
                    </div>
                    <div *ngSwitchCase="'program'">
                        <div *ngIf="!loadingProgram">
                            <app-program-summary
                                [program]="selectedApplicationListProgram"
                                [user]="chainedApplications[0].User"
                            ></app-program-summary>
                        </div>
                    </div>
                </div>
            </ion-col>
        </ion-row>
    </ion-grid>
    <ion-grid fixed *ngIf="loading">
        <ion-row class="ion-justify-content-center">
            <ion-col size="12">
                <ion-card>
                    <ion-list>
                        <ion-item>
                            <ion-avatar slot="start">
                                <ion-skeleton-text animated></ion-skeleton-text>
                            </ion-avatar>
                            <ion-label>
                                <h3>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 50%"
                                    ></ion-skeleton-text>
                                </h3>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 80%"
                                    ></ion-skeleton-text>
                                </p>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 60%"
                                    ></ion-skeleton-text>
                                </p>
                            </ion-label>
                        </ion-item>
                        <ion-item>
                            <ion-label>
                                <h3>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 50%"
                                    ></ion-skeleton-text>
                                </h3>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 80%"
                                    ></ion-skeleton-text>
                                </p>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 60%"
                                    ></ion-skeleton-text>
                                </p>
                            </ion-label>
                        </ion-item>
                        <ion-item>
                            <ion-skeleton-text
                                animated
                                style="width: 27px; height: 27px"
                                slot="start"
                            ></ion-skeleton-text>
                            <ion-label>
                                <h3>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 50%"
                                    ></ion-skeleton-text>
                                </h3>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 80%"
                                    ></ion-skeleton-text>
                                </p>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 60%"
                                    ></ion-skeleton-text>
                                </p>
                            </ion-label>
                        </ion-item>
                        <ion-item>
                            <ion-skeleton-text
                                animated
                                style="width: 27px; height: 27px"
                                slot="start"
                            ></ion-skeleton-text>
                            <ion-label>
                                <h3>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 50%"
                                    ></ion-skeleton-text>
                                </h3>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 80%"
                                    ></ion-skeleton-text>
                                </p>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 60%"
                                    ></ion-skeleton-text>
                                </p>
                            </ion-label>
                        </ion-item>
                        <ion-item>
                            <ion-skeleton-text
                                animated
                                style="width: 27px; height: 27px"
                                slot="start"
                            ></ion-skeleton-text>
                            <ion-label>
                                <h3>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 50%"
                                    ></ion-skeleton-text>
                                </h3>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 80%"
                                    ></ion-skeleton-text>
                                </p>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 60%"
                                    ></ion-skeleton-text>
                                </p>
                            </ion-label>
                        </ion-item>
                        <ion-item>
                            <ion-skeleton-text
                                animated
                                style="width: 27px; height: 27px"
                                slot="start"
                            ></ion-skeleton-text>
                            <ion-label>
                                <h3>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 50%"
                                    ></ion-skeleton-text>
                                </h3>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 80%"
                                    ></ion-skeleton-text>
                                </p>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 60%"
                                    ></ion-skeleton-text>
                                </p>
                            </ion-label>
                        </ion-item>
                        <ion-item>
                            <ion-skeleton-text
                                animated
                                style="width: 27px; height: 27px"
                                slot="start"
                            ></ion-skeleton-text>
                            <ion-label>
                                <h3>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 50%"
                                    ></ion-skeleton-text>
                                </h3>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 80%"
                                    ></ion-skeleton-text>
                                </p>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 60%"
                                    ></ion-skeleton-text>
                                </p>
                            </ion-label>
                        </ion-item>
                        <ion-item>
                            <ion-skeleton-text
                                animated
                                style="width: 27px; height: 27px"
                                slot="start"
                            ></ion-skeleton-text>
                            <ion-label>
                                <h3>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 50%"
                                    ></ion-skeleton-text>
                                </h3>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 80%"
                                    ></ion-skeleton-text>
                                </p>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 60%"
                                    ></ion-skeleton-text>
                                </p>
                            </ion-label>
                        </ion-item>
                        <ion-item>
                            <ion-skeleton-text
                                animated
                                style="width: 27px; height: 27px"
                                slot="start"
                            ></ion-skeleton-text>
                            <ion-label>
                                <h3>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 50%"
                                    ></ion-skeleton-text>
                                </h3>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 80%"
                                    ></ion-skeleton-text>
                                </p>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 60%"
                                    ></ion-skeleton-text>
                                </p>
                            </ion-label>
                        </ion-item>
                    </ion-list>
                </ion-card>
                <ion-card>
                    <ion-list>
                        <ion-item>
                            <ion-avatar slot="start">
                                <ion-skeleton-text animated></ion-skeleton-text>
                            </ion-avatar>
                            <ion-label>
                                <h3>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 50%"
                                    ></ion-skeleton-text>
                                </h3>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 80%"
                                    ></ion-skeleton-text>
                                </p>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 60%"
                                    ></ion-skeleton-text>
                                </p>
                            </ion-label>
                        </ion-item>
                        <ion-item>
                            <ion-label>
                                <h3>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 50%"
                                    ></ion-skeleton-text>
                                </h3>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 80%"
                                    ></ion-skeleton-text>
                                </p>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 60%"
                                    ></ion-skeleton-text>
                                </p>
                            </ion-label>
                        </ion-item>
                        <ion-item>
                            <ion-skeleton-text
                                animated
                                style="width: 27px; height: 27px"
                                slot="start"
                            ></ion-skeleton-text>
                            <ion-label>
                                <h3>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 50%"
                                    ></ion-skeleton-text>
                                </h3>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 80%"
                                    ></ion-skeleton-text>
                                </p>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 60%"
                                    ></ion-skeleton-text>
                                </p>
                            </ion-label>
                        </ion-item>
                        <ion-item>
                            <ion-skeleton-text
                                animated
                                style="width: 27px; height: 27px"
                                slot="start"
                            ></ion-skeleton-text>
                            <ion-label>
                                <h3>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 50%"
                                    ></ion-skeleton-text>
                                </h3>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 80%"
                                    ></ion-skeleton-text>
                                </p>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 60%"
                                    ></ion-skeleton-text>
                                </p>
                            </ion-label>
                        </ion-item>
                        <ion-item>
                            <ion-skeleton-text
                                animated
                                style="width: 27px; height: 27px"
                                slot="start"
                            ></ion-skeleton-text>
                            <ion-label>
                                <h3>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 50%"
                                    ></ion-skeleton-text>
                                </h3>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 80%"
                                    ></ion-skeleton-text>
                                </p>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 60%"
                                    ></ion-skeleton-text>
                                </p>
                            </ion-label>
                        </ion-item>
                        <ion-item>
                            <ion-skeleton-text
                                animated
                                style="width: 27px; height: 27px"
                                slot="start"
                            ></ion-skeleton-text>
                            <ion-label>
                                <h3>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 50%"
                                    ></ion-skeleton-text>
                                </h3>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 80%"
                                    ></ion-skeleton-text>
                                </p>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 60%"
                                    ></ion-skeleton-text>
                                </p>
                            </ion-label>
                        </ion-item>
                        <ion-item>
                            <ion-skeleton-text
                                animated
                                style="width: 27px; height: 27px"
                                slot="start"
                            ></ion-skeleton-text>
                            <ion-label>
                                <h3>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 50%"
                                    ></ion-skeleton-text>
                                </h3>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 80%"
                                    ></ion-skeleton-text>
                                </p>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 60%"
                                    ></ion-skeleton-text>
                                </p>
                            </ion-label>
                        </ion-item>
                        <ion-item>
                            <ion-skeleton-text
                                animated
                                style="width: 27px; height: 27px"
                                slot="start"
                            ></ion-skeleton-text>
                            <ion-label>
                                <h3>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 50%"
                                    ></ion-skeleton-text>
                                </h3>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 80%"
                                    ></ion-skeleton-text>
                                </p>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 60%"
                                    ></ion-skeleton-text>
                                </p>
                            </ion-label>
                        </ion-item>
                        <ion-item>
                            <ion-skeleton-text
                                animated
                                style="width: 27px; height: 27px"
                                slot="start"
                            ></ion-skeleton-text>
                            <ion-label>
                                <h3>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 50%"
                                    ></ion-skeleton-text>
                                </h3>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 80%"
                                    ></ion-skeleton-text>
                                </p>
                                <p>
                                    <ion-skeleton-text
                                        animated
                                        style="width: 60%"
                                    ></ion-skeleton-text>
                                </p>
                            </ion-label>
                        </ion-item>
                    </ion-list>
                </ion-card>
            </ion-col>
        </ion-row>
    </ion-grid>
</ion-content>
